import React from 'react'
import MatchingConditions from './MatchingConditions';
import { AttributeSorting } from './AttributeSorting';

type IterationContentProps = {
    activeTab: string;
    iterationId: string;
    iterationName: number;
    iterationPayload: CategoryData | undefined
    setIterationPayload: React.Dispatch<React.SetStateAction<CategoryData | undefined>>
};

const IterationContent: React.FC<IterationContentProps> = ({ activeTab, iterationId, iterationPayload, setIterationPayload }) => {
    return (
        <div data-testid={`iteration-content-${iterationId}`}>
            {activeTab === 'matchingConditions' ? (
                <div data-testid="matching-conditions-content">
                    <MatchingConditions />
                </div>
            ) : (
                <div data-testid="attributes-sorting-content">
                    {iterationPayload && <AttributeSorting categoryData={iterationPayload} onCategoryDataChange={setIterationPayload} />}
                </div>
            )}
        </div>
    );
};

export default IterationContent